import React, { useEffect, useRef, useState } from 'react'
import { appsearchProps } from './appsearch-interface'
import { Input } from 'antd'
import Searchcategory from './searchcategory/searchcategory'
//@ts-ignore
import debounce from 'lodash.debounce';
import { appSearch } from '../../../api/search/search';
import {
  LoadingOutlined,
} from '@ant-design/icons';
import { openNotificationWithIcon } from '../../../utils/helper';

const Appsearch = ({ open, closeModal }: appsearchProps) => {
  const componentRef = useRef<HTMLDivElement>(null);

  const [searchInput, setSearchInput] = useState('')
  const [loading, setLoading] = useState(false)
  const [searchResult, setSearchResult] = useState<any>({
    students: [],
    teachers: [],
    lessons: [],
    classes: [],
    curriculums: [],
  })
  const [filters, setFilters] = useState([
    {
      title: 'Students',
      value: 'student',
      active: true,
    },
    {
      title: 'Teachers',
      value: 'teacher',
      active: true,
    },
    {
      title: 'Lessons',
      value: 'lesson',
      active: true
    },
    {
      title: 'Classes',
      value: 'class',
      active: true
    },
    {
      title: 'Curriculum',
      value: 'curriculum',
      active: true
    }
  ])

  const removeFilter = (index: number) => {
    const newFilters = [...filters]
    newFilters[index].active = false
    setFilters(newFilters)
  }

  const fetchResults = async (value: string) => {
    try {
      setLoading(true)

      const payload: any = {}

      filters.forEach((item) => {
        if (item.active === true) {
          payload[`${item.value}`] = value
        }
      })


      const res = await appSearch({
        ...payload
      })

      const { data } = res.data

      setSearchResult(data)


      setLoading(false)


    } catch (error: any) {
      setLoading(false)
      if (error?.response) {
        openNotificationWithIcon('error', 'Search', `${error?.response?.data?.message || 'Something went wrong'}`)
      } else {
        openNotificationWithIcon('error', 'Search', 'Something went wrong')
      }
    }
  }

  const getResults = debounce((value: string) => {
    if (value.trim() !== '') {
      fetchResults(value.trim().toLocaleLowerCase())
      setSearchInput(value.trim().toLocaleLowerCase())
    }
  }, 300)


  useEffect(() => {
    const handleOutsideClick = (event: MouseEvent) => {
      if (
        componentRef.current &&
        !componentRef.current.contains(event.target as Node)
      ) {
        closeModal();
      }
    };

    document.addEventListener('mousedown', handleOutsideClick);

    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
    };

    // eslint-disable-next-line
  }, []);

  return (
    <div className='fixed top-0 left-0 w-full h-full bg-appcolordeepblack z-[4000] overflow-y-hidden'>
      <div className='pt-[2rem] mx-auto w-[50%] z-[5000]' ref={componentRef}>
        <div className='flex items-center bg-appcolorwhite border-appcolorgreyfaint border-[2px]  border-solid rounded-[15px] px-[0.6rem] py-[0.7rem] h-[3rem] mb-[0.62rem]'
        >
          <div>
            <img src="/img/vectors/search.svg" alt="search" />
          </div>
          <Input
            size="small"
            placeholder='Search...'
            bordered={false}
            className="w-full mr-4 bg-appcolorwhite custom-transparent-input-navbar-search full-input"
            onChange={(e: any) => {
              getResults(e.target.value)
            }}
          />
          {
            loading ?
              <div className='mb-[0.5rem]'>
                <LoadingOutlined />
              </div> :
              null
          }
        </div>

        <div className='bg-appcolorwhite rounded-[15px] p-[0.9rem]'>
          <div className='mb-[1rem] p-[1rem] bg-appcolorgreyfive rounded-[15px]'>
            <div className='flex justify-between mb-[0.9rem]'>
              <p className='text-appcolorblackfaint'>Searching in</p>
              <div>
                <img src="/img/vectors/purplefilter.svg" alt="" />
              </div>
            </div>

            <div className='flex'>
              {
                filters.map((item, index) => (
                  item.active ?
                    <div className='flex items-center border border-appcpolordeepblacktwo rounded-[35px] py-[0.4rem] px-[0.5rem] mr-[0.5rem]' key={`filter-${item.value}`}>
                      <span className='text-appcolorblackfaint mr-[0.4rem]'>{item.title}</span>
                      {
                        filters.filter((item) => item.active === true).length === 1 ? null :
                          <div>
                            <img src="/img/vectors/tagclose.svg" alt="" className='cursor-pointer' onClick={() => {
                              removeFilter(index)
                            }} />
                          </div>
                      }
                    </div> : null
                ))
              }
            </div>
          </div>

          {/* <Searchcategory
            title="Recent Search"
          /> */}

          <div>
            {
              searchInput?.length > 0 ?
                <>
                  {
                    filters.map((item) => (
                      item.active && searchResult[`${item.title.toLowerCase()}`]?.length > 0 ?
                        <Searchcategory
                          key={`searchitem-${item.value}`}
                          title={item.title}
                          searchType={item.value}
                          results={searchResult[`${item.title.toLowerCase()}`]}
                        />
                        : null
                    ))
                  }
                </> :
                null
            }
          </div>
        </div>
      </div>
    </div>
  )
}

export default Appsearch